<div class="outer">
    <highcharts-chart 
        [Highcharts]="Highcharts"
        [callbackFunction]="setChartObject"
        [ngStyle]="{'height': chartHeight}"
        [oneToOne]="true"
        [options]="options"
        [(update)]="updateFlag"
        class="chart-container"></highcharts-chart>
</div>